import { BaseModel } from "@/models/base/BaseModel";
import { v4 as uuidv4 } from "uuid";

export class GuestbookVisitor extends BaseModel {
  isPrimary: boolean;
  name: string;
  visitorPhone: string;

  constructor(name: string, visitorPhone: string, isPrimary = true) {
    super();

    this.id = uuidv4();
    this.name = name;
    this.visitorPhone = visitorPhone;
    this.isPrimary = isPrimary;
  }
}
